import { t } from "i18next";
import { ApiError, ApiServiceError } from "libs/api";
import { toast } from "react-hot-toast";

import { PackErrorCode } from "../constants";

export const handlePackError = (error: ApiServiceError<ApiError>): boolean => {
  const data = error.response?.data as
    | (ApiError & { code?: string; metadata?: Record<string, unknown> })
    | undefined;
  const code = data?.code;
  const metadata = data?.metadata;

  switch (code) {
    case PackErrorCode.TitleAlreadyExists:
      toast.error(t("Pack with this title already exists"));
      return true;
    case PackErrorCode.ShortIdAlreadyExists:
      toast.error(t("Pack with this short ID already exists"));
      return true;
    case PackErrorCode.SlotsRequired:
      toast.error(t("Pack must have at least one slot"));
      return true;
    case PackErrorCode.DuplicateSlotPosition:
      toast.error(
        `${t("Two slots share the same position")}: ${metadata?.position ?? ""}`
      );
      return true;
    case PackErrorCode.SlotOptionsRequired:
      toast.error(
        `${t("Slot must have at least one option")} (${t("slot")} ${metadata?.slotPosition ?? ""})`
      );
      return true;
    case PackErrorCode.OptionVariantNotFound:
      toast.error(t("Selected variant no longer exists"));
      return true;
    case PackErrorCode.PackNotFound:
      toast.error(t("Pack not found"));
      return true;
    case PackErrorCode.PackInactive:
      toast.error(t("Pack is inactive"));
      return true;
    case PackErrorCode.PriceBelowMinBuyingPrice: {
      const min = (metadata?.minBuyingPriceCombination as number) ?? 0;
      toast.error(
        `${t("Pack price is below the minimum buying-price combination")} (${min.toLocaleString("en-US")} FCFA). ${t("Enable the override checkbox to allow it.")}`
      );
      return true;
    }
    default:
      return false;
  }
};
